'use strict';

import { FilterType } from "../constants";

export const toggleNavPane = ({ commit }) => {
	commit('toggleNavPane');
};

//=================================================================================================================

export const setView = ({ commit }, view) => {
	commit('setView', { view });
};

//=================================================================================================================

export const fetchStaticAppData = async ({ commit }) => {
	const data = await import(/* webpackChunkName: "static" */ `@/assets/data/static-${process.env.VUE_APP_DATA}.js`);
	commit('setStaticAppData', data);
};

//=================================================================================================================

export const fetchDisclaimer = async ({ commit }) => {
	const data = await import(/* webpackChunkName: "disclaimer" */ `@/assets/data/disclaimer-${process.env.VUE_APP_DATA}.js`);
	commit('setDisclaimer', data);
};

//=================================================================================================================

export const fetchAppData = async ({ dispatch, commit, getters }) => {
	const userID = getters['auth/userID'];

	await Promise.all([
		dispatch('fetchStaticAppData'),
		dispatch('actions/fetchAll'),
		dispatch('likes/fetchOwnLikes', userID),
		dispatch('comments/fetchOwnComments', userID),
		dispatch('feedbacks/fetchOwnFeedbacks', userID),
		dispatch('search/search'),
	]);
	
	commit('setAppReady');
};

//=================================================================================================================

export const unloadAppData = async ({ commit }) => {
	commit('unsetAppReady');
	commit('actions/unsetReady');

	commit('actions/clearAll');
	commit('likes/clearAll');
	commit('comments/clearAll');
	commit('feedbacks/clearAll');
};

//=================================================================================================================

export const handlePagination = ({ commit }, { params }) => {
	const [type, value] = (params.filter || '').split('-');
	const isSearch = type === FilterType.search;

	commit('search/setQuery', isSearch ? value : null);
	commit('actions/filter', { type, value });
};
